import axios from "axios";
import { server } from "../../server";

// Отримання категорій
export const getCategories = () => async (dispatch) => {
  try {
    dispatch({ type: "categoriesRequest" });

    const { data } = await axios.get(`${server}/category/get-categories`);

    dispatch({ type: "categoriesSuccess", payload: data.categories });
  } catch (error) {
    dispatch({
      type: "categoriesFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};


// Створення категорії
export const createCategory = (categoryData) => async (dispatch) => {
  try {
    dispatch({ type: "createCategoryRequest" });
    const { data } = await axios.post(
      `${server}/category/create-category`,
      categoryData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "createCategorySuccess", payload: data.category });
  } catch (error) {
    dispatch({
      type: "createCategoryFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Оновлення категорії
export const updateCategory = (id, categoryData) => async (dispatch) => {
  try {
    dispatch({ type: "updateCategoryRequest" });
    const { data } = await axios.put(
      `${server}/category/update-category/${id}`,
      categoryData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: "updateCategorySuccess", payload: data.category });
  } catch (error) {
    dispatch({
      type: "updateCategoryFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};

// Видалення категорії
export const deleteCategory = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteCategoryRequest" });
    await axios.delete(`${server}/category/delete-category/${id}`);
    dispatch({ type: "deleteCategorySuccess", payload: id });
  } catch (error) {
    dispatch({
      type: "deleteCategoryFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};


export const getProductsByCategory = (categoryId) => async (dispatch) => {
  try {
    dispatch({ type: "productsByCategoryRequest" });

    const { data } = await axios.get(`${server}/category/${categoryId}`);

    dispatch({ type: "productsByCategorySuccess", payload: data.products });
  } catch (error) {
    dispatch({
      type: "productsByCategoryFail",
      payload: error.response?.data?.message || error.message,
    });
  }
};